/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const updateRoutineOverrideBodyStartRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const updateRoutineOverrideBodyEndRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const updateRoutineOverrideBodySubstituteUserIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const updateRoutineOverrideBodyReasonMax = 1000;

export const updateRoutineOverrideBodyExpectedVersionExclusiveMin = 0;
export const updateRoutineOverrideBodyExpectedVersionMax = 9007199254740991;

export const UpdateRoutineOverrideBody = zod.object({
  start: zod.iso.datetime({ offset: true }).regex(updateRoutineOverrideBodyStartRegExp).optional(),
  end: zod.iso.datetime({ offset: true }).regex(updateRoutineOverrideBodyEndRegExp).optional(),
  substituteUserId: zod.uuid().regex(updateRoutineOverrideBodySubstituteUserIdRegExp).optional(),
  reason: zod.string().max(updateRoutineOverrideBodyReasonMax).optional(),
  expectedVersion: zod
    .int()
    .gt(updateRoutineOverrideBodyExpectedVersionExclusiveMin)
    .max(updateRoutineOverrideBodyExpectedVersionMax),
});

export type UpdateRoutineOverrideBody = zod.input<typeof UpdateRoutineOverrideBody>;
export type UpdateRoutineOverrideBodyOutput = zod.output<typeof UpdateRoutineOverrideBody>;
